module.exports = __webpack_public_path__ + "static/img/fj.0be05cf9.svg";